export type Platform = "ios" | "android" | "pc" | "demo" | "native_ios" | "native_android";

export const getPlatform = (): Platform => {
  // In mobile apps, the user agent cannot be obtained
  const ua = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) {
    return "ios";
  }
  if (/android/.test(ua)) {
    return "android";
  }
  return "pc";
};

export const isWebPlatform = () => {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
};

export const isMobileAgent = () => {
  return getPlatform() === "ios" || getPlatform() === "android";
};
